/**
 * Steps in Wizard. If experiment steps should be added, add them here.
 */
// eslint-disable-next-line no-shadow, @typescript-eslint/no-shadow
export enum SignupSteps {
  EXPLAIN_THE_WIZARD = 'explainTheWizard',
  BOX_SIZE = 'boxSize',
  POSTCODE = 'postcode',
  DELIVERY = 'delivery',
  DELIVERY_DATE = 'deliveryDate',
  PERSONALISE_MENU = 'personaliseMenu',
  BOX_SIZE_PRICE_BREAKDOWN = 'boxSizePriceBreakdown',
}
